import { DataGridPro, GridColumns } from '@mui/x-data-grid-pro'
import { Button } from '@mui/material'
import { MemberDto } from '@services/api'
import { useEffect, useState } from 'react'
import { OrderService } from '@services/OrderService'

type Props = {
  onSelect: (member: MemberDto) => void
}

const MemberDoctorList: React.FC<Props> = ({ onSelect }) => {
  const [members, setMembers] = useState<MemberDto[]>([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setIsLoading(true)
    OrderService.findDoctorMembers()
      .then(setMembers)
      .finally(() => setIsLoading(false))
  }, [])

  const columns: GridColumns = [
    { field: 'firstName', headerName: 'Prénom', flex: 1 },
    { field: 'lastName', headerName: 'Nom', flex: 1 },
    { field: 'rppsNumber', headerName: 'RPPS', flex: 1 },
    {
      field: 'actions',
      headerName: 'Action',
      width: 130,
      renderCell: (params) => (
        <Button
          size="small"
          variant="contained"
          onClick={() => onSelect(params.row)}
        >
          Sélectionner
        </Button>
      ),
    },
  ]

  return (
    <DataGridPro
      sx={{ height: '100%', width: '100%', display:'flex' }}
      rows={members}
      columns={columns}
      loading={isLoading}
    />
  )
}

export default MemberDoctorList
